document.querySelector("#lokalizacja_1")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/pGdkiJVSRfR3XLzm9");
  },
  false,
);

document.querySelector("#lokalizacja_2")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/MKrsjfEaEHhvpz8W6");
  },
  false,
);

document.querySelector("#lokalizacja_3")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/6ALbUHR87w8B5xcm6");
  },
  false,
);

document.querySelector("#lokalizacja_4")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/GFyEWFe65oKAe6nW9");
  },
  false,
);

document.querySelector("#lokalizacja_5")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/2fQ9J4NKTm26CorX8");
  },
  false,
);

document.querySelector("#lokalizacja_6")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/3BiN7DNRfGZyHzg79");
  },
  false,
);

document.querySelector("#lokalizacja_7")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/2a6CbQRmSViJy6Am9");
  },
  false,
);

document.querySelector("#lokalizacja_8")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/d32fYAHz4CvriPcg7");
  },
  false,
);

document.querySelector("#lokalizacja_9")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/25tZ1yeGM2vxexmU7");
  },
  false,
);

document.querySelector("#lokalizacja_10")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/QEaoVSyesrxuEQfZ8");
  },
  false,
);

document.querySelector("#lokalizacja_11")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/ZBSxUZn1wNPJaQBKA");
  },
  false,
);

document.querySelector("#lokalizacja_12")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/GecCYZry3rRnL7eT6");
  },
  false,
);

document.querySelector("#lokalizacja_13")?.addEventListener(
  "click",
  function (e) {
    window.open("https://maps.app.goo.gl/xaHmDN8uDVd2bSP18");
  },
  false,
);
